// extracted by mini-css-extract-plugin
export default {"container":"InteropActionsMenu_container__0uhpk","dropdown":"InteropActionsMenu_dropdown__0bd0Z"};